import { Button, Checkbox } from "antd";
import type { CheckboxValueType } from "antd/es/checkbox/Group";
import React from "react";

type CustomFilterDropdownProps = {
  selectedKeys: React.Key[];
  setSelectedKeys: (keys: React.Key[]) => void;
  confirm: () => void;
  clearFilters?: () => void;
  filters?: { text: React.ReactNode; value: string | number | boolean }[];
  okButtonText?: string;
  resetButtonText?: string;
};

const CustomFilterDropdown: React.FC<CustomFilterDropdownProps> = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  clearFilters,
  filters = [],
  okButtonText = "OK",
  resetButtonText = "Reset",
}) => {
  const options = filters.map((f) => ({
    label: f.text,
    value: f.value,
  }));

  const onChange = (checkedValues: CheckboxValueType[]) => {
    setSelectedKeys(checkedValues as React.Key[]);
  };

  return (
    <div style={{ padding: 8 }}>
      <div style={{ maxHeight: 250, overflowY: "auto", padding: "0 8px" }}>
        <Checkbox.Group
          style={{ display: "flex", flexDirection: "column", gap: 4 }}
          options={options}
          value={selectedKeys}
          onChange={onChange}
        />
      </div>
      <div
        style={{
          marginTop: 8,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          type="link"
          size="small"
          onClick={() => {
            clearFilters?.();
          }}
        >
          {resetButtonText}
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => {
            confirm();
          }}
        >
          {okButtonText}
        </Button>
      </div>
    </div>
  );
};

export default CustomFilterDropdown;
